"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OidcToken = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _jwtDecode = require("jwt-decode");
/* eslint-disable @typescript-eslint/naming-convention -- Token properties don't follow our rules */ var OidcToken = function OidcToken(token) {
    var _this = this;
    _class_call_check(this, OidcToken);
    (0, _defineProperty2.default)(this, "token", void 0);
    (0, _defineProperty2.default)(this, "payload", void 0);
    (0, _defineProperty2.default)(this, "toString", function() {
        return _this.token;
    });
    (0, _defineProperty2.default)(this, "getClaim", function(claim) {
        return _this.payload[claim];
    });
    if (typeof token === 'string') {
        this.token = token;
    } else {
        this.token = token.Token;
    }
    this.payload = (0, _jwtDecode.jwtDecode)(this.token);
};
exports.OidcToken = OidcToken; //# sourceMappingURL=OidcToken.js.map
